import { generatePath } from 'react-router-dom';
import { Routes } from 'src/shared/constants/routes';
export const generateEditUrl = (page) => {
    return {
        pathname: generatePath(Routes.ManagePage, {
            pageId: page.id,
            moduleId: page.moduleId,
            pageType: page.type.toLowerCase()
        }),
        search: location.search
    };
};
